import React, { useEffect, useState, useCallback, useRef } from "react";
import baseUrl from "../../../../api/baseUrl";
import AppointmentCounts from "../../appointment/viewappointment/components/AppointmentCounts";
import AppointmentFilter from "../../appointment/viewappointment/components/AppointmentFilter";
import AppointmentTr from "../../appointment/viewappointment/components/AppointmentTr";
import CommonLayout from "../../../../layouts/commonLayout/CommonLayout";
import CommonNav from "../../../../layouts/commonNav/CommonNav";
import "../../appointment/viewappointment/viewappointment.scss";
import Container from "../../../../layouts/containers/Container";
import { io } from "socket.io-client";
import socketauth from "../../../../api/socket";
import TabBar from "../../../../components/tabbar/TabBar";
import BottomTab from "../../../../components/pagination/BottomTab";

const LIMIT = 20;

// Memoize the AppointmentTr component to avoid unnecessary re-renders
const MemoizedAppointmentTr = React.memo(AppointmentTr);
const socket = io(`${process.env.REACT_APP_WS}`, socketauth);
function MyAppointment() {
  const [appointment, setAppointment] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState({
    appointments: 0,
    cancelled: 0,
    completed: 0,
    pending: 0,
    inqueue: 0,
    reschudle: 0,
    ongoing: 0,
    noshow: 0,
  });
  const [all, setAll] = useState("all");
  const [selectedOption, setSelectedOption] = useState<string>("pending");
  const pageRef = useRef(1);
  pageRef.current = page;

  const getAppointments = useCallback(
    (status: any, dayFilter: string, pageNum: number = 1) => {
      baseUrl
        .get("/appointment/findAllAppointmentDentistId", {
          headers: {
            status: status,
            day: dayFilter,
            page: pageNum,
            limit: LIMIT,
          },
        })
        .then((response) => {
          setAppointment(response.data.data || []);
          setTotalCount(response.data.count ?? 0);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    []
  );

  const handleOptionChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSelectedOption(value);
      setPage(1);
      getAppointments(value, all, 1);
    },
    [all, getAppointments]
  );

  const handleDay = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setAll(value);
      setPage(1);
      getAppointments(selectedOption, value, 1);
    },
    [selectedOption, getAppointments]
  );

  const onPageChange = useCallback((newPage: number) => {
    setPage(newPage);
    getAppointments(selectedOption, all, newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedOption, all, getAppointments]);

  const appointmentCount = useCallback(() => {
    baseUrl
      .get("/appointment/appointmentscountsbyId", {
        headers: { status: true },
      })
      .then((response) => {
        setCount({
          appointments: response.data?.appointments,
          cancelled: response.data?.cancelled,
          completed: response.data?.completed,
          pending: response.data?.pending,
          inqueue: response.data?.inqueue,
          reschudle: response.data?.reschudle,
          noshow: response.data?.noshow,
          ongoing: response.data?.ongoing,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const appointmStatus = useCallback(() => {
    getAppointments(selectedOption, all, pageRef.current);
    appointmentCount();
  }, [getAppointments, appointmentCount, selectedOption, all]);

  // useEffect runs only once due to empty dependency array
  useEffect(() => {
    appointmStatus();
  }, [appointmStatus]);

  return (
    <>
      <TabBar title={"My Appointments"} />
      <div className="view-appointment">
        <Container>
          <AppointmentCounts count={count} />
        </Container>
        <Container className="all-appointment">
          <AppointmentFilter
            selectedOption={selectedOption}
            all={all}
            handleOptionChange={handleOptionChange}
            handleDay={handleDay}
          />
          <table>
            <thead>
              <tr>
                <th>PATIENT NAME</th>
                <th>APPOINTMENT DATE</th>
                <th>TIME SLOT</th>
                <th>STATUS</th>
                <th>PURPOSE</th>
                <th>TYPE</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {appointment.map((item: any, index: number) => (
                <MemoizedAppointmentTr
                  appointmStatus={appointmStatus}
                  key={index}
                  item={item}
                />
              ))}
            </tbody>
          </table>
          {totalCount > LIMIT && (
            <BottomTab
              title="Appointments"
              count={totalCount}
              onPageChange={onPageChange}
            />
          )}
        </Container>
      </div>
    </>
  );
}

export default React.memo(MyAppointment);
